/**
 * Thrown by our orval-generated `backendApi.ts` hooks for any non-2xx HTTP
 * response — see `override.fetch.forceSuccessResponse` in `orval.config.mjs`.
 * `info` holds the parsed response body, typically `ProblemDetails`
 * optionally extended with app-specific `key`/`message`/`params` fields (the
 * convention already used ad hoc in BtnAskForQuote/BtnImportConfigId/
 * BtnJumpToEasy/BtnNeedHelp).
 */
export type HttpError = Error & { status: number; info?: unknown };

export function isHttpError(error: unknown): error is HttpError {
  return (
    error instanceof Error && typeof (error as HttpError).status === "number"
  );
}
